import React, { useState, useEffect } from "react";
import EditOutlined from "@material-ui/icons/EditOutlined"
import { useTranslation } from "react-i18next";
import { Button, Grid } from '@material-ui/core';
import Search from "../../../components/Search/Search";
import CustomizeView from "../../../components/DataTable/CustomizeView/CustomizeView";
import Filters from "../../../components/DataTable/Filters/Filters";
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import DataTable from "../../../components/DataTable/DataTable";
import AddActioneerProfile from "./addActioneerProfile/AddActioneerProfile";
import ProfileService from "../../../services/ProfileService/ProfileService";
import { alertState } from "./../../../recoil-store/recoil-state";
import { useSetRecoilState } from 'recoil';

let selectedItems = [];
let setSelectedAutomRow;

const ActioneerProfile = (props) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [searchData, setSearchData] = useState([])
    const [loading, setLoading] = useState(false); // default true
    const [customColumn, setCustomColumn] = useState([])
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [edit, setEdit] = useState({ type: "add", id: "" });
    const [openDelete, setOpenDelete] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const setAlert = useSetRecoilState(alertState);

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true);
        selectedItems = [];
        for (let i of rowsDeleted.data) {
            selectedItems.push(searchData[i.dataIndex].id);
        }
        setSelectedAutomRow = setSelectedRows;
    };
    function handleOpen(open, setState) { setState(!open); setEdit({ type: "add", id: "" }) }

    useEffect(() => {
        fetchData().then(r => r)
    }, [refresh]);

    const fetchData = async () => {
        setLoading(true);
        const resp = await ProfileService.getAllActioneersProfile();
        if (resp) {
            if (resp?.data) {
                if (Array.isArray(resp?.data)) {
                    setData(resp.data);
                    setSearchData(resp?.data)
                }
                else {
                    setData([]);
                    setSearchData([])
                }
            }
        }
        setLoading(false);
    }

    const handleDelete = async () => {
        let ids = selectedItems;
        setLoadingDelete(true);
        const response = await ProfileService.deleteActioneerProfile(ids);
        if (response) {
            if (response.status) {
                setSelectedAutomRow([]);
                fetchData().then(r => r)
            }
            setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.ACTIONEER-PROFILE.' + response.message), severity: response.status ? 'success' : 'error' }))
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoadingDelete(false);
    };

    const handleEdit = (id) => {
        if (id) {
            setEdit({ type: 'edit', id });
            setOpenAdd(!openAdd);
        }
    }
    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "name",
                label: t("CONTENT.AUTOMS-LIST.AUTOM-NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 2,
                name: "description",
                label: t("CONTENT.AUTOMS-LIST.DESCRIPTION"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            if (searchData[dataIndex]?.description === '') {
                                searchData[dataIndex].description = "-";
                            }
                            return searchData[dataIndex]?.description;
                        }
                    },
                }
            },
            {
                id: 3,
                name: "type",
                label: t("CONTENT.AUTOMS-LIST.TYPE"),
                options: { filter: true, sort: true },
            },
            {
                id: 4,
                name: "actions",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                        if (searchData[dataIndex]) {
                            return (
                                <div style={{ display: "flex" }} onClick={() => handleEdit(searchData[dataIndex].id)}>
                                    <Button size="small">
                                        <EditOutlined fontSize="small" color="disabled" style={{ margin: '0 5px 0 -20px' }} />
                                        <span className="db-sublabel">{t('CONTENT.WEBHOOK.EDIT')}</span>
                                    </Button>
                                </div>
                            );
                        }
                    },
                },
            },
        ]
        setCustomColumn(column)

    }, [searchData, t, setCustomColumn])
    return (
        <>
            <div id="credential-container">
                <Search data={data} setSearchData={setSearchData} searchKey={['name', 'description']} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}>
                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                        <Button className="searchbar-button" onClick={() => handleOpen(openAdd, setOpenAdd)}>Add Actioneer Profile</Button>
                        <Button className="searchbar-button" onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                        <Button className="searchbar-button" onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                    </Grid>
                </Search>

                <Grid
                    item
                    sm={12}
                    data-test="listautom-page"
                >
                    <DataTable
                        data-test="automlist-datatable"
                        customColumns={customColumn}
                        onRowsDelete={handleRowsDelete}
                        selectableRows="multiple"
                        data={searchData ? searchData : []}
                        loading={loading}
                        loadingDelete={loadingDelete}
                    />
                    {openAdd && <AddActioneerProfile setOpen={setOpenAdd} setRefresh={setRefresh} edit={edit} />}
                    {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t("CONTENT.ACTIONEER-PROFILE.DELETE-MESSAGE")} deleteFunc={handleDelete} />}
                    {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
                    {openFilters && <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
                </Grid>

            </div>
        </>
    )
}

export default ActioneerProfile;
